module.exports = __webpack_public_path__ + "media/images/mailer/activation_customer/clickworker/load_data_de-107730e1316bd4c67a55a8a39bd51fd1.gif";